import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Bet, BetStatus } from '../domain/Bet.domain'

interface UpdateBetInput {
  id: string
  thesis?: string
  categoryId?: string
  ownerId?: string
  status?: BetStatus
}

export const useUpdateBet = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateBetInput) => {
      const response = await api.patch<Bet>(`/bets/${id}`, data)
      return response.data
    },
    onMutate: async ({ id, ...data }) => {
      await queryClient.cancelQueries({ queryKey: [QueryKeys.Bets] })
      const previous = queryClient.getQueryData<Bet[]>([QueryKeys.Bets])

      queryClient.setQueryData<Bet[]>([QueryKeys.Bets], (old) =>
        old?.map((b) => (b.id === id ? { ...b, ...data } : b))
      )

      return { previous }
    },
    onError: (_err, _vars, context) => {
      queryClient.setQueryData([QueryKeys.Bets], context?.previous)
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Bets] })
    },
  })
}
